import React, { useEffect } from "react";
import "../../../style/landing.css";

import img1 from "../../../image/privacy-pop-right-img.webp";
import img2 from "../../../image/privacy-pop-img-left.webp";

import Navbar from "../navbar/Navbar";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const privacyPolicySections = [
    {
      title: "1. Information We Collect",
      items: [
        {
          title: "Personal Information",
          description:
            "When you create an account or use our services, we collect data like your name, email address, company details, and payment information.",
        },
        {
          title: "Usage Data",
          description:
            "Information about your interactions with our platform, such as IP address, browser type, pages visited, and usage patterns, is collected automatically.",
        },
        {
          title: "Cookies and Tracking Technologies",
          description:
            "We use cookies to enhance your experience, track engagement, and gather insights. You can manage cookies via your browser settings.",
        },
        {
          title: "Payment Information",
          description:
            "For paid plans, we collect payment details securely via trusted third-party payment processors.",
        },
      ],
    },
    {
      title: "2. How We Use Your Information",
      items: [
        {
          title: "Enhance your experience",
          description:
            "Personalize and optimize email campaigns using AI-driven tools, including behavior-based personalization and smart send-time optimization.",
        },
        {
          title: "Provide support",
          description:
            "Address questions, troubleshoot issues, and improve overall platform performance.",
        },
        {
          title: "Communicate with you",
          description:
            "Send product updates, newsletters, and promotional materials. You can opt out of marketing emails anytime.",
        },
        {
          title: "Process payments",
          description: "Manage subscription billing securely.",
        },
        {
          title: "Analyze and optimize",
          description:
            "Use aggregated data to improve platform features and user experience.",
        },
      ],
    },
    {
      title: "3. How We Share Your Information",
      items: [
        {
          title: "Trusted service providers",
          description:
            "For hosting, analytics, payment processing, and email delivery.",
        },
        {
          title: "Business transactions",
          description:
            "If NewsletterAI undergoes a merger, acquisition, or sale, your information may be transferred with the business.",
        },
        {
          title: "Legal compliance",
          description:
            "To comply with applicable laws or valid legal requests, such as subpoenas or court orders.",
        },
      ],
    },
  ];

  return (
    <>
      <header className="lp-hero-container hero-section">
        <div className="lp-container">
          <Navbar />
          <h1 className="lp-heading">
            Privacy <span style={{ color: "#00BFA6" }}>Policy </span>
          </h1>
          <section className="lp-wailist-section">
            <img
              src={img2}
              alt="Privacy Policy Illustration Left"
              className="side-img"
            />
            <p className="lp-heading-desc">
              Your privacy matters. We safeguard your data while helping you{" "}
              <br />
              create impactful, personalized newsletters.
            </p>
            <img
              src={img1}
              alt="Privacy Policy Illustration Right"
              className="side-img"
              style={{ marginTop: "-80px" }}
            />
          </section>
        </div>
      </header>

      <main className="lp-container">
        <article className="privacy-policy">
          <p className="effective-date">Effective Date: 20-01-2025</p>
          <p>
            At NewsletterAI, we are committed to safeguarding your privacy and
            ensuring the secure handling of your personal data. This privacy
            policy outlines how we collect, use, and share your information when
            you access or use our newsletter automation and personalization
            services.
          </p>
          <p>
            By using NewsletterAI, you consent to the collection and use of your
            data in line with this privacy policy.
          </p>
          {privacyPolicySections.map((section, index) => (
            <section key={index}>
              <h2>{section.title}</h2>
              <ul>
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <strong>{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </article>
      </main>
    </>
  );
};

export default Privacy;
